import { render, staticRenderFns } from "./Copy.vue?vue&type=template&id=d9023fa4&"
import script from "./Copy.vue?vue&type=script&setup=true&lang=js&"
export * from "./Copy.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports